import * as React from 'react'

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import Button from './Button'

export type CircularButtonProps = {
  diameter: React.CSSProperties['height'] & React.CSSProperties['width']
} & React.ComponentProps<typeof Button>

export default styled(Button)<CircularButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  padding: 0;

  ${({ diameter }) => css`
    width: ${diameter};
    height: ${diameter};
  `}
`
